import React from 'react'
import { ContextToolbar, useTraversal } from '@guillotinaweb/react-gmi'
import { TabsPanelWithLock } from '../../../components/tab-panel-with-lock'
import { AuditLogTab } from '../../../common/auditlog'
import { Data } from './Data'
import { Redirects } from './Redirects'
import { SEOTab } from '../../../components/seo-tab'
import { Sections } from './Sections'
import { SubmenuTab } from '../../../components/submenu-tab'
import { SafePanelPermissions } from '../../../components/safe-panel-permissions'

import './styles.css'

export function LandingView(props) {
  const ctx = useTraversal()
  const calculated = ctx.filterTabs(
    {
      Data,
      Sections,
      Redirects,
      Permissions: SafePanelPermissions,
      AuditLog: AuditLogTab,
      SEO: SEOTab,
      Submenu: SubmenuTab,
    },
    {
      Data: 'guillotina.ModifyContent',
      Sections: 'guillotina.ModifyContent',
      Redirects: 'guillotina.ModifyContent',
      Permissions: 'guillotina.SeePermissions',
      AuditLog: 'vinissimus.ViewLogs',
      SEO: 'guillotina.ModifyContent',
      Submenu: 'guillotina.ModifyContent',
    }
  )

  return (
    <TabsPanelWithLock
      tabs={calculated}
      currentTab="Data"
      editableTabs={['Data', 'Sections', 'Redirects']}
      rightToolbar={<ContextToolbar {...props} />}
      {...props}
    />
  )
}
